<template>
  <div class="container"> 
    <!-- 渐变背景层 -->
    <div class="background-layer">
      <!-- 问候语模块 -->
      <div class="greeting" v-if="pageIdx === 1">
        <div class="greeting-sub">欢迎预约</div>
        <div class="greeting-sub">星辰守护号夜间休息区</div>
      </div>

      <!-- 信息确认卡片 -->
      <div class="info-card" v-if="pageIdx === 2">
        <div class="greeting2">
          <span class="greeting-text2">尊敬的</span>
          <span class="highlight-name2">{{ formData.name }}</span>
          <span class="greeting-text2">{{ selectedGenderShow }}</span>
        </div>
        <div class="remind-text2">请确认您的信息是否正确</div>
      </div>
      <!-- 主内容容器 -->
      <div class="content-card">
        <!-- 表单区域 -->
        <div class="form-container">
          <van-field
            label="姓名"
            label-width="100px"
            placeholder="请输入姓名"
            v-model="formData.name"
            :readonly="pageIdx === 2"
            :error-message="nameErrMsg"
          />
          <van-field
            label="证件类型"
            label-width="100px"
            :value="selectedCardType"
            placeholder="请选择证件类型"
            :error-message="cardTypeErrMsg"
            readonly
            @click="cardTypePickerClick"
          />
          <van-field
            label="证件号"
            label-width="100px"
            placeholder="请输入证件号"
            maxlength="18"
            v-model="formData.idNumber"
            :readonly="pageIdx === 2"
            :error-message="idNumberErrMsg"
          />
          <van-field
            label="手机号"
            label-width="100px"
            placeholder="请输入手机号"
            maxlength="11"
            v-model="formData.tel"
            :readonly="pageIdx === 2"
            :error-message="telErrMsg"
          />
          <van-field
            label="性别"
            label-width="100px"
            :value="selectedGender"
            placeholder="请选择性别"
            :error-message="genderErrMsg"
            readonly
            @click="genderPickerClick"
          />
        <local-filter-select
          v-model="formData.trainNumber"
          :options="stationList"
          :error-message="trainNumberErrMsg"
          label="车次选择"
          placeholder="请选择车次"
          :readonly="pageIdx === 2"
          @select="handleSelect"
        />
        <van-field
            label="申请类型"
            label-width="100px"
            :value="selectedSq"
            placeholder="请选择类型"
            :error-message="sqErrMsg"
            readonly
            @click="sqPickerClick"
          />
        <van-field
            label="出发站"
            label-width="100px"
            v-model="formData.start_station_name"
            :readonly="(formData.sqType==='1'&&pageIdx === 1) || pageIdx === 2"
            :error-message="startErrMsg"
            v-if="trainShow"
          >
        </van-field>
        <van-field
            label="到达站"
            label-width="100px"
            v-model="formData.end_station_name"
            :readonly="(formData.sqType==='2'&&pageIdx === 1) || pageIdx === 2"
            :error-message="endErrMsg"
            v-if="trainShow"
          >
        </van-field>
        <van-field
          label="预约入住时间"
          :value="formData.appointmentTime"
          @click="showDateTimePicker2"
        >
        </van-field>
        
        <van-field
          label="出发时间"
          :value="formData.formattedTime"
          readonly
          @click="showDateTimePicker"
        >
        </van-field>

        <!-- <van-field
          name="have_children"
          label-width="1px"
        >
          <template #input>
            <van-checkbox 
              v-model="formData.have_children" 
              shape="square"
              checked-color="#07c160"
              :disabled="pageIdx === 2"
            >
              带小孩出行
            </van-checkbox>
          </template>
        </van-field> -->
      <div class="protocol-agreement" v-show="pageIdx===1">
        <label class="checkbox-label">
           <van-checkbox 
              v-model="modelValue1" 
              shape="square"
              checked-color="#07c160"
              :disabled="pageIdx === 2 || !modelValue"
            >
            </van-checkbox>
        </label>
        <!-- 使用按钮样式，提示用户可点击 -->
        <button type="button" @click="isProtocolVisible = true" class="protocol-link">
          我已阅读申请须知《申请须知》
        </button>
        
        <!-- 协议模态框 -->
        <div v-if="isProtocolVisible" class="protocol-modal" @click.self="isProtocolVisible = false">
          <div class="protocol-modal-content">
            <header class="modal-header">
              <h2 style="color: crimson;">杭州东站“星辰守护”旅客夜间休息区</h2>
              <h2>旅客须知（试运行）</h2>
            </header>
            <div class="protocol-text">
              <h3>第一条 开放时间</h3>
              <p>常规开放时间为每日22时至次日8时，特殊情况时根据实际需求调整开放时段，通过相关渠道对外公布。</p>
              <h3>第二条 适用范围</h3>
              <p>本休息区实行实名登记制，凭本人有效身份证件及符合相关要求火车票提出申请。</p>
              <p>适用旅客：</p>
              <p>出发：持有当天杭州东站出发、出发时间为当日23时至次日7时30分火车票的旅客；</p>
              <p>抵达：夜间23时50分以后抵达杭州东站且有进出站记录的旅客；</p>
              <p>换乘：持有当天23时50分以后抵达的上一程车票信息且下一程出发时间为次日7时30分以前的车票信息的旅客。</p>              
              <p>预约：预约成功后，请务必在填写的“预计时间”内，抵达东广场“星辰守护一号车厢”服务台核销登记，逾期30分钟未办理的，预约将自动失效，名额实时释放给其他旅客。</p>
              <p>核销：预约成功后，请务必在填写的“预计时间”内，抵达东广场“星辰守护一号车厢”服务台核销登记，逾期30分钟未办理的，预约将自动失效，名额实时释放给其他旅客。</p>
              <h3>第三条  旅客行为规范</h3>
               <p>1、旅客进入休息区后应遵守现场工作人员引导，由现场工作人员安排休息座椅，不得随意更换座椅，不得抢占、霸占多个座椅（如将行李放在邻座、躺卧占用多个座椅等），不得随意挪动休息区设施。</p>
              <p>2、携带行李的旅客应将行李放在自身座位旁或指定行李存放区，不得堵塞通道、安全出口等处，不得影响他人正常通行，自觉听从现场工作人员的指挥。贵重物品应自行妥善保管，管理单位不承担物品丢失责任。</p>
              <p>3、休息区实行“静音管理”，进入休息区的旅客应将手机、电子设备调至震动或静音模式，不得大声交谈、喧哗，不得公开播放音乐、视频等音频内容，影响其他旅客正常休息。</p>
              <p>4、旅客应爱护休息区环境，不得随地吐痰、乱扔垃圾，不得在座椅、墙面、设施上刻画、涂鸦。</p>
              <p>5、旅客不得做出任何影响公共安全的行为和动作。</p>
              <p>6、携带儿童的旅客，请看管好儿童，确保儿童在现场活动的安全，并保持车厢内安静的环境，不得在车厢内追逐、打闹，影响其他旅客正常休息。</p>
              <h3>第四条  特殊旅客服务</h3>
              <p>特殊旅客（孕妇、残障人士、携带儿童推车的旅客等）可向现场工作人员提出协助进出、协助物品放置等事宜。</p>
              <p>如有身体不适请寻求服务台工作人员求助。</p>
              <h3>第五条  服务设施</h3>
              <p>本休息区配备以下基础设施：休息座椅、空调、照明系统、饮水设备、消毒设备、充电插座、应急药品箱。</p>
              <p>如有故意损坏休息区设施设备等情况应照价赔偿。</p>
              <h3>第六条 禁止违规行为</h3>
              <p>1、休息区禁止饮酒人员进入。</p>
              <p>2、休息区内禁止吸烟（含电子烟）、饮酒，禁止携带易燃易爆、有毒有害、管制刀具等危险物品，禁止从事赌博、推销、乞讨等违法违规或扰乱公共秩序的活动。</p>
              <p>3、旅客不得在休息区随地躺卧、脱鞋、赤膊，不得做出其他不文明、不礼貌的行为，旅客应听从现场工作人员劝阻、劝导。</p>
              <p>4、不得在休息区食用较大气味、易影响他人的食物。</p>
              <p>如有旅客违反上述相关条款的，工作人员首先进行口头劝阻，告知违规行为及后果，引导其整改；旅客拒不配合的，工作人员有权做好相关证据留存，并要求其离开休息区。</p>
              <h3>第七条  黑名单制度</h3>
              <p>经核实，存在以下行为的旅客，列入黑名单，不得再进入本休息区：（1）多次存在违反《杭州东站“星辰守护”旅客夜间休息区旅客须知（试运行）》相关文明管理要求的；（2）经核实，在本休息区休息但实际无进出站记录的旅客，即进入预警名单，第二次在本休息区休息但实际无进出站记录的旅客即列入黑名单；（3）携带危险物品进入休息区，危及公共安全的；（4）拒不配合各项管理、辱骂殴打工作人员，或扰乱休息区秩序，造成恶劣影响的；（5）故意损坏休息区设施设备，造成重大财产损失的；（6）从事违反法律法规规定的。</p>
              <h3>第八条 服务容量</h3>
              <p>本休息区实行容量管理，休息座椅满员即停止对外开放。</p>
              <h3>第九条  其他</h3>
              <p>本须知的最终解释权归杭州东站管理委员会所有。本须知在实施过程中，如遇制度调整，杭州东站枢纽管理委员会将适时修订并予以公布。</p>  
            
        
                  <p style="text-align: right;">杭州东站枢纽管理委员会</p> 
                  <p style="text-align: right;"> 2025年9月26日</p>
            </div>
            <footer style="text-align: center;">
              <van-button type="primary" 
                      class="modal-footer-submit-btn"
                      @click="handleAgreeAndClose">同意并关闭</van-button>
            </footer>
          </div>
        </div>
      </div>
          <captcha-input
            :phone-number="userPhone"
            :is-phone-valid="isPhoneValid"
            @get-captcha="onGetCaptcha"
            @input-complete="onCodeComplete"
            @input-change="onCodeChange"
            v-if = "pageIdx === 2"
          />
      

          <!-- 日期选择弹出层 -->
          <van-popup v-model="showPicker" position="bottom" round>
            <van-datetime-picker
              v-model="currentDate"
              type="datetime"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="onDateTimeConfirm"
              @cancel="onDateTimeCancel"
           />
          </van-popup>

           <!-- 日期选择弹出层 -->
          <van-popup v-model="showPicker2" position="bottom" round>
            <van-datetime-picker
              v-model="currentDate2"
              type="datetime"
              :min-date="minDate2"
              :max-date="maxDate2"
              @confirm="onDateTimeConfirm2"
              @cancel="onDateTimeCancel2"
           />
          </van-popup>

          <!-- 性别选择弹出层 -->
          <van-popup v-model="showGenderPicker" position="bottom" round>
            <van-picker
              title="选择性别"
              :columns="genderOptions"
              show-toolbar
              value-key="label"
              @confirm="onGenderConfirm"
              @cancel="onGenderCancel"
            />
          </van-popup>
          <!-- 申请类型选择弹出框-->
          <van-popup v-model="showSqPicker" position="bottom" round>
            <van-picker
              title="选择申请类型"
              :columns="sqOptions"
              show-toolbar
              value-key="label"
              @confirm="onSqConfirm"
              @cancel="onSqCancel"
            />
          </van-popup>
          
          <!-- 证件类型选择弹出层 -->
          <van-popup v-model="showCardTypePicker" position="bottom" round>
            <van-picker
              title="选择证件类型"
              :columns="cardTypeOptions"
              show-toolbar
              value-key="label"
              @confirm="onCardTypeConfirm"
              @cancel="onCardTypeCancel"
            />
          </van-popup>
        </div>
      </div>
     
      <!-- <p style="color: red;">注意：提交申请后会收到验证码短信请注意查收</p> -->

      <!-- 底部按钮 -->
      <div class="submit-section" v-if="pageIdx === 1">
        <van-button
          type="primary"
          round
          block
          class="submit-btn"
          @click="handleSubmit"
        >
          提交申请
        </van-button>
      </div>

      <div class="submit-section" v-if="pageIdx === 2">
        <van-button
          type="primary"
          round
          class="submit-btn"
          @click="handleSureSubmit"
        >
          确认提交
        </van-button>
        <van-button
          type="primary"
          round
          class="submit-btn2"
          @click="handleReturn"
        >
          返回填写
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import cache from '@/utils/cacheUtils';
import api from '@/utils/api';

// 添加中文支持
moment.locale('zh-cn')

export default {
  data() {
    return {
      isProtocolVisible: false,
      userPhone: '',
      pageIdx: 1,
      modelValue: false,
      modelValue1: false,
      showPicker: false,
      showPicker2: false,
      showGenderPicker: false,
      showSqPicker: false,
      showCardTypePicker: false,
      trainShow:false,
      idNumberErrMsg:"",
      nameErrMsg:"",
      startErrMsg:"",
      endErrMsg:"",
      telErrMsg:"",
      genderErrMsg:"",
      sqErrMsg:"",
      cardTypeErrMsg:"",
      trainNumberErrMsg:"",
      currentDate: new Date(2025, 3, 25, 19, 0),
      currentDate2: new Date(),
      minDate: new Date(2025, 0, 1),
      maxDate: new Date(2099, 12, 31),
      minDate2: new Date(),
      maxDate2: new Date(2099, 12, 31),
      genderOptions: [
        { label: '男', value: '0' },
        { label: '女', value: '1' },
      ],
      sqOptions: [
        { label: '出发', value: '1' },
        { label: '到达', value: '2' },
        { label: '中转换乘', value: '3' },
      ],
      cardTypeOptions: [
        { label: '身份证', value: '1' },
        { label: '护照', value: '2' },
        { label: '军官证', value: '3' },
        { label: '学生证', value: '4' },
      ],
      selectedGender: '',
      selectedSq: '',
      selectedGenderShow: '',
      selectedSqShow:'',
      selectedCardType:'身份证',
      labelTime:'出发时间',
      stationList:[],
      itemRawData:{},
      defStationName:"杭州东",
      //验证码
      verificationCode: '',
      formData: {
        name: '',
        cardType:'1',
        sqType:'',
        idNumber: '',
        tel: '',
        start_station_name: '',
        end_station_name: '',
        gender: '',
        have_children: false, 
        trainNumber: '',
        formattedTime: '',
        appointmentTime: '',
      }
    };
  },
  mounted() {
    this.loadCacheData();
    this.initStation();
  },
   watch: {
    // 监听formData的trainNumber属性
    'formData.name': function(newVal, oldVal) {
      if(!newVal){
        this.nameErrMsg = "姓名不能为空";
      }else{
        this.nameErrMsg = "";
      }
    },
    'formData.tel': function(newVal, oldVal) {
      const phoneRegex = /^1[3-9]\d{9}$/
      if(!newVal){
        this.telErrMsg = "手机号不能为空";
      }else if(!phoneRegex.test(newVal)){
        this.telErrMsg = "手机号输入错误";
      }else{
        this.telErrMsg = "";
      }
    },
    'formData.gender': function(newVal, oldVal) {
      if(!newVal){
        this.genderErrMsg = "性别不能为空";
      }else{
        this.genderErrMsg = "";
      }
    },
    'formData.sqType': function(newVal, oldVal) {
      if(!newVal){
        this.sqErrMsg = "申请类型不能为空";
      }else{
        this.sqErrMsg = "";
      }
    },
    'formData.trainNumber': function(newVal, oldVal) {
      if(!newVal){
        this.trainNumberErrMsg = "车次不能为空";
      }else{
        this.trainNumberErrMsg = "";
      }
    },
    'formData.idNumber': function(newVal, oldVal) {
      var that = this;
      if(that.formData.cardType==='1'){
        var d =  that.validateIDCard(newVal);
        if(!d.valid){
          that.idNumberErrMsg = "身份证格式错误";
        }else{
          that.idNumberErrMsg = "";
          //根据身份证获取性别
          var gender = that.getGenderFromIdCard(newVal);
          that.formData.gender = gender;
          that.selectedGender = gender === '0' ? '男' : '女';
          that.selectedGenderShow = gender === '0' ? '先生' : '女士';
          
        }
      }else{
        if(!newVal){
          that.idNumberErrMsg = "证件格式错误格式错误";
        }else{
          that.idNumberErrMsg = "";
        }
      }
      
    }
  },
  computed: {
    isPhoneValid() {
      return /^1[3-9]\d{9}$/.test(this.userPhone);
    },
    cardTypeMap() {
      const map = new Map();
      this.cardTypeOptions.forEach(option => {
        map.set(option.value, option.label);
      });
      return map;
    },
    sqTypeMap() {
      const map = new Map();
      this.sqOptions.forEach(option => {
        map.set(option.value, option.label);
      });
      return map;
    }
  },
  methods: {
    getLabelByValue(value) {
      return this.cardTypeMap.get(value) || value;
    },
    getSqLabelByValue(value) {
      return this.sqTypeMap.get(value) || value;
    },
     handleSelect(item) {
      this.trainShow = true;
      // this.$toast(`您选择了: ${item.text}`);
      this.formData.start_station_name = item.rawData.start_station_name;
      this.formData.end_station_name = item.rawData.end_station_name;
      this.formData.formattedTime = item.rawData.depart_time;
      this.formData.trainNumber = item.rawData.train_number;
      this.itemRawData = item.rawData;
    },
    handleAgreeAndClose() {
      this.isProtocolVisible = false;
      this.modelValue = true;// 同意后开放勾选
      this.modelValue1 = true;
    },
    showDateTimePicker() {
       this.showPicker = true;
       this.minDate = new Date();
    },
    showDateTimePicker2() {
       this.showPicker2 = true;
       const today = new Date();
       // 最小时间：今天晚上22:00
       this.minDate2 = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 22, 0, 0);
       // 最大时间：次日早上6:00
       const tomorrow = new Date(today);
       tomorrow.setDate(today.getDate() + 1);
       this.maxDate2 = new Date(tomorrow.getFullYear(), tomorrow.getMonth(), tomorrow.getDate(), 6, 0, 0);
       // 默认选中今天22:00
       const now = new Date();
       if (now.getHours() >= 22) {
         this.currentDate2 = now;
       } else {
         this.currentDate2 = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 22, 0, 0);
       }
    },
    loadCacheData() {
      const formData = cache.get('formData');
      if (formData) {
        this.formData = formData;
        this.selectedGender = formData.gender;
        this.selectedGenderShow = formData.gender === '0' ? '先生' : '女士';
        this.selectedSq = this.getSqLabelByValue(formData.sqType);
        this.selectedCardType = this.getLabelByValue(formData.cardType);
        this.trainShow = true;
      } else {
        this.formData = {
          name: '',
          cardType:'1',
          sqType:'',
          idNumber: '',
          tel: '',
          gender: '',
          trainNumber: '',
          start_station_name: '',
          end_station_name: '',
          have_children: false, 
          // formattedTime: moment().format('YYYY-MM-DD HH:mm'),
          formattedTime: ''
        }
        this.trainShow = false;
        this.selectedCardType = '身份证';
      }
    },
    initStation(){
      var that= this;
       try {
          api.get('/v1/getTrainInfo')
          .then(response => {
            if(response.data.code === 0){
              that.stationList = response.data.data;
            }else{
              //失败
              that.$toast(response.data.msg);
            }
          })
          .catch(error => {
            that.$toast('请求失败:'+ error);
          });
      } catch (error) {
        // 可以根据错误状态码进行更细致的处理
        if (error.response && error.response.status === 404) {
          that.errorMessage = '请求的资源不存在。';
          that.$toast('请求的资源不存在。,请刷新后重试');
        }else{
          that.$toast('调用接口出错,请刷新后重试');
        }
      } 
    },
    onDateTimeConfirm(value) {
      this.formData.formattedTime = moment(value).format('YYYY-MM-DD HH:mm');
      this.showPicker = false;
    },
    onDateTimeCancel() {
      this.showPicker = false;
    },
    onDateTimeConfirm2(value) {
      this.formData.appointmentTime = moment(value).format('YYYY-MM-DD HH:mm');
      this.showPicker2 = false;
    },
    onDateTimeCancel2() {
      this.showPicker2 = false;
    },
    genderPickerClick() {
      if (this.pageIdx === 1) {
        this.showGenderPicker = true;
      }
    },
    sqPickerClick() {
      if (this.pageIdx === 1) {
        this.showSqPicker = true;
      }
    },
    cardTypePickerClick() {
       if (this.pageIdx === 1) {
         this.showCardTypePicker = true;
       }
    },
    onGenderConfirm(value) {
      this.selectedGender = value.label
      this.selectedGenderShow = value.label === '男' ? '先生' : '女士';
      this.formData.gender = value.value;
      this.showGenderPicker = false;
    },
    onGenderCancel() {
      this.showGenderPicker = false;
    },
    onSqConfirm(value) {
      this.selectedSq = value.label
      this.formData.sqType = value.value;
      if(value.value === '1'){
        this.formData.start_station_name = this.defStationName;
        this.formData.end_station_name = '';
        this.labelTime = "出发时间";
      }else if(value.value === '2'){
        this.formData.end_station_name = this.defStationName;
        this.formData.start_station_name = '';
        this.labelTime = "出发时间";
      }else{
        this.formData.start_station_name = '';
        this.formData.end_station_name = '';
        this.labelTime = "出发时间";
      }
      this.showSqPicker = false;
    },
    onSqCancel() {
      this.showSqPicker = false;
    },
    onCardTypeConfirm(value) {
      this.selectedCardType = value.label;
      this.formData.cardType = value.value;
      this.showCardTypePicker = false;
      this.checkCard();
    },
    onCardTypeCancel() {
      this.showCardTypePicker = false;
    },
    checkCard(){
      var that = this;
      //验证身份证--后续身份证类型的才加验证
      if(that.formData.cardType === '1'){
        var d =  that.validateIDCard(that.formData.idNumber);
        if(!d.valid){
          that.idNumberErrMsg = "身份证格式错误";
          return;
        }else{
          that.idNumberErrMsg = "";
          //根据身份证获取性别
          if( that.formData.gender !== that.getGenderFromIdCard(that.formData.idNumber)){
            that.$toast('身份证信息与性别不匹配');
            return;
          }
        }
      }else{
        if(!that.formData.idNumber){
          that.idNumberErrMsg = "证件格式错误";
        }else{
          that.idNumberErrMsg = "";
        }
      }
    },
    handleSubmit() {
      var that = this;
      // 验证当前时间不能是12点前
      const now = new Date();
      const currentHour = now.getHours();
      if (currentHour < 12) {
        that.$toast('每天中午12:00开放当日服务预约，请等待!');
        return;
      }
      var isok = true;
      //验证姓名
       if(!that.formData.name){
        that.nameErrMsg = "姓名不能为空";
        isok = false;
      }else{
        that.nameErrMsg = "";
      }
      //验证证件号
       if(!that.formData.idNumber){
        that.idNumberErrMsg = "证件号不能为空";
        isok = false;
      }else{
        that.idNumberErrMsg = "";
      }
      //验证出发站
       if(!that.formData.start_station_name){
        that.startErrMsg = "出发站不能为空";
        isok = false;
      }else{
        that.startErrMsg = "";
      }
      
      //验证到达站
       if(!that.formData.end_station_name){
        that.endErrMsg = "到达站不能为空";
        isok = false;
      }else{
        that.endErrMsg = "";
      }
      
      //验证手机号
      const phoneRegex = /^1[3-9]\d{9}$/
      if(!that.formData.tel){
        that.telErrMsg = "手机号不能为空";
        isok = false;
      }else if(!phoneRegex.test(that.formData.tel)){
        that.telErrMsg = "手机号输入错误";
      }else{
        that.telErrMsg = "";
      }
      //验证性别
      if(!that.formData.gender){
        that.genderErrMsg = "性别不能为空";
        isok = false;
      }else{
        that.genderErrMsg = "";
      }
      if(!that.formData.trainNumber){
        that.trainNumberErrMsg = "车次不能为空";
        isok = false;
      }else{
        that.trainNumberErrMsg = "";
      }
      //验证申请类型
      if(!that.formData.sqType){
        that.sqErrMsg = "申请类型不能为空";
        isok = false;
      }else{
        that.sqErrMsg = "";
      }
      if(!isok){
        return;
      }
      if(!that.trainShow){
        that.$toast('请获取车次信息');
        return;
      }
      if(!that.modelValue1){
        that.$toast("请同意相关协议");
        return;
      }
      if(!that.isAppointmentTimeValid()){
        return;
      }
      that.pageIdx = 2;
      that.userPhone = that.formData.tel;
    },
    validateIDCard(idCard) {
      // 移除可能存在的空格
      idCard = idCard.trim();
      // 1. 基础格式正则验证 (兼容15位和18位)
      // 修复正则表达式，更严格验证15位身份证
      const idCardPattern = /^(^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$)|(^[1-9]\d{5}(50|60|70|80|90|0[0123456789])\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}$)/;
      if (!idCardPattern.test(idCard)) {
        return { valid: false, message: "身份证号码格式不正确" };
      }

      // 2. 出生日期验证
      let year, month, day;
      if (idCard.length === 15) {
        // 15位身份证：6-7位为年份（取后两位），8-9位为月份，10-11位为日期
        year = parseInt('19' + idCard.substring(6, 8));
        month = parseInt(idCard.substring(8, 10));
        day = parseInt(idCard.substring(10, 12));
      } else {
        // 18位身份证：7-10位为年份，11-12位为月份，13-14位为日期
        year = parseInt(idCard.substring(6, 10));
        month = parseInt(idCard.substring(10, 12));
        day = parseInt(idCard.substring(12, 14));
      }

      // 检查年份范围
      const currentYear = new Date().getFullYear();
      if (year < 1900 || year > currentYear) {
        return { valid: false, message: "身份证年份无效" };
      }

      // 检查月份范围
      if (month < 1 || month > 12) {
        return { valid: false, message: "身份证月份无效" };
      }

      // 检查日期范围
      const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      // 处理闰年2月
      if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
        daysInMonth[1] = 29;
      }
      if (day < 1 || day > daysInMonth[month - 1]) {
        return { valid: false, message: "身份证日期无效" };
      }

      // 3. 如果是18位身份证，进行校验码验证
      if (idCard.length === 18) {
        const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
        let sum = 0;

        for (let i = 0; i < 17; i++) {
          sum += parseInt(idCard[i]) * weights[i];
        }
        const mod = sum % 11;
        const calculatedCheckCode = checkCodes[mod];
        const actualCheckCode = idCard[17].toUpperCase();

        if (calculatedCheckCode !== actualCheckCode) {
          return { valid: false, message: "身份证校验码错误" };
        }
      }

      return { valid: true, message: "身份证号码格式正确" };
    },
    /**
     * 根据身份证号码获取性别
     * @param {string} idCard - 身份证号码
     * @returns {string} '男'、'女' 或空字符串（格式错误时）
     */
    getGenderFromIdCard(idCard) {
      if (!idCard) {
        return '';
      }

      // 基础格式验证：简单判断15位或18位
      if (idCard.length !== 15 && idCard.length !== 18) {
        return '';
      }

      let genderDigit;
      // 根据身份证长度提取性别位
      if (idCard.length === 15) {
        // 15位身份证：取最后一位（第15位）
        genderDigit = parseInt(idCard.substring(14, 15));
      } else {
        // 18位身份证：取第17位
        genderDigit = parseInt(idCard.substring(16, 17));
      }

      // 判断奇偶性并返回性别
      // 使用取模运算，奇数的模为1，偶数的模为0
      return genderDigit % 2 === 1 ? '0' : '1';
    },
    isAppointmentTimeValid() {
      // 处理空值情况
      if (!this.formData.appointmentTime) {
        this.$toast('请选择预约入住时间');
        return false; 
      }
      if (!this.formData.formattedTime) {
        this.$toast('请选择出发时间');
        return false;
      }
      // 方法1：转换为Date对象比较时间戳[1,6](@ref)
      const appointment = new Date(this.formData.appointmentTime.replace(' ', 'T'));
      const formatted = new Date(this.formData.formattedTime.replace(' ', 'T'));
      if(appointment.getTime() <= formatted.getTime()){
        return true;
      }else{
        this.$toast('预约入住时间不能晚于出发时间');
        return false;
      }
    },
    handleSureSubmit() {
      var that = this;
      // 验证当前时间不能是12点前
      const now = new Date();
      const currentHour = now.getHours();
      if (currentHour < 12) {
        that.$toast('每天中午12:00开放当日服务预约，请等待!');
        return;
      }
      if(this.formData.gender=='男'){
        this.formData.gender = '0';
      }
      if(this.formData.gender=='女'){
        this.formData.gender = '1';
      }
      cache.set('formData', that.formData, 5);
      if (!that.verificationCode) {
        that.$toast('请输入验证码');
        return;
      }
      try {
          const data ={
              //申请类型: 1-预约 2-登记
              "application_portal": "1",
              "application_type": this.formData.sqType,
              "name": this.formData.name,
              "card_id": this.formData.idNumber,
              "card_type":this.formData.cardType,
              "sex":this.formData.gender,
              "tel":this.formData.tel,
              "train":this.formData.trainNumber,
              "start_station_name":this.formData.start_station_name,
              "end_station_name":this.formData.end_station_name,
              "have_children":this.formData.have_children,
              "appointment_time":this.formData.appointmentTime,
              "departure_time":this.formData.formattedTime,
              "verify_code":this.verificationCode
          };
          api.post('/v1/reserve', data)
          .then(response => {
            if(response.data.code === 0){
              const submitData = {
                ...that.formData,
                application_portal: data.application_portal,
                application_type: data.application_type
              }
              //成功
              that.$router.push({
                path: '/qrcodeShow',
                query: submitData
              });
            }else{
              console.log("handleSureSubmit-----4-------->"+response.data?.data);
              //失败
              that.$toast(response.data.msg);
            }
          })
          .catch(error => {
            that.$toast('请求失败:'+ error);
          });
      } catch (error) {
        // 可以根据错误状态码进行更细致的处理
        if (error.response && error.response.status === 404) {
          this.errorMessage = '请求的资源不存在。';
          this.$toast('请求的资源不存在。,请刷新后重试');
        }else{
          this.$toast('调用接口出错,请刷新后重试:'+error);
        }
      } 
    },
    handleReturn() {
      this.pageIdx = 1;
    },
    // 处理获取验证码
    onGetCaptcha(phone) {
      // 调用后端API发送验证码
      var that= this;
       try {
          api.post('/v1/verifyCode/'+phone)
          .then(response => {
            if(response.data.code === 0){
                this.$toast('验证码已发送:');
            }else{
              //失败
              that.$toast(response.data.msg);
            }
          })
          .catch(error => {
            that.$toast('请求失败:'+ error);
          });
      } catch (error) {
        // 可以根据错误状态码进行更细致的处理
        if (error.response && error.response.status === 404) {
          that.errorMessage = '请求的资源不存在。';
          that.$toast('请求的资源不存在。,请刷新后重试');
        }else{
          that.$toast('调用接口出错,请刷新后重试');
        }
      } 
    },
    // 处理验证码输入完成
    onCodeComplete(fullCode) {
      this.verificationCode = fullCode;
      // console.log('验证码输入完成:', fullCode);
      // 可以在这里添加自动提交逻辑
    },
    // 处理验证码输入变化
    onCodeChange(code) {
      // console.log('验证码变化:', code);
    }
  }
}
</script>

<style scoped>

/* 在全局样式中添加 */
.van-field {
  padding: 14px 0 !important;
  /* display: block !important; */
}
.container {
  position: relative;
  min-height: 100vh;
}

.background-layer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  background: linear-gradient(180deg, #85b1f6 0%, #e0f6ff 100%);
  z-index: 0;
}

.content-card {
  position: relative;
  margin: 10px;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  z-index: 1;
}

.greeting {
  padding: 10px 10px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3),
    0 0 5px rgba(255, 0, 0, 0.2);
}

.greeting-main {
  display: block;
  font-size: 32px;
  font-weight: 600;
  color: white;
  margin-left: 25px;
}

.greeting-sub {
  font-size: 20px;
  color: white;
  margin-left: 25px;
}

.info-card {
  padding: 24px 16px;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3),
    0 0 5px rgba(255, 0, 0, 0.2);
}

.greeting-text2 {
  color: white;
  font-size: 27px;
}

.highlight-name2 {
  color: #ffd700;
  font-size: 27px;
  font-weight: bold;
  margin: 0 4px;
}

.remind-text2 {
  color: white;
  font-size: 19px;
  opacity: 0.9;
}

.form-container {
  padding: 0 20px;
}

.calendar-icon {
  width: 24px;
  height: 24px;
}

.submit-section {
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
}

.submit-btn {
  border-radius: 5px !important;
  background: #2275ff !important;
  box-shadow: 0 2px 8px rgba(9, 94, 180, 0.3);
  width: 125px !important;
  margin: 10px;
}

.submit-btn2 {
  border-radius: 5px !important;
  background: #f70505 !important;
  box-shadow: 0 2px 8px rgba(9, 94, 180, 0.3);
  width: 125px !important;
  margin: 10px;
}
.preview-container {
  background: #fff;
  padding: 20px;
}

.protocol-agreement {
  height: 80px;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-left: -20px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 20px;
}

.protocol-link {
  background: none;
  border: none;
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  margin-left: -20px;
}

.protocol-link:hover {
  color: #40a9ff;
}

/* 模态框样式 */
.protocol-modal {
  /* 遮罩层样式 */
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* 协议模态框 - 内容区域样式 */
.protocol-modal-content {
  /* 布局与尺寸 */
  display: flex;
  flex-direction: column;
  max-width: 800px; /* 最大宽度限制，避免在大屏幕上过宽 */
  width: 90vw; /* 视口宽度百分比，保持响应式 */
  min-height: 100vh; /* 最大高度限制，避免过高 */
  background: #ffffff;
  border-radius: 12px; /* 圆角设计，现代感 */
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2); /* 阴影效果，增加层次感 */
  overflow: hidden; /* 防止内容溢出圆角 */
}

/* 模态框头部 */
.modal-header {
  padding: 10px 24px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

.modal-header h2 {
  font-size: 0.5rem;
}

/* 协议正文区域 - 可滚动内容 */
.protocol-text {
  flex: 1; /* 占据剩余空间 */
  padding: 24px;
  overflow-y: auto; /* 内容过多时显示滚动条 */
  line-height: 1.6;
  color: #333;
  font-size: 14px;
  text-align: left;
  
  /* 自定义滚动条样式 (Webkit浏览器) */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
}

/* 协议文本内容样式 */
.protocol-text p {
  margin-bottom: 1em;
}

.protocol-text h3 {
  color: #555;
  margin: 1.5em 0 0.5em 0;
  font-size: 0.3rem;
}

.protocol-text ul, .protocol-text ol {
  padding-left: 1.5em;
  margin-bottom: 1em;
}

/* 模态框底部 - 操作区域 */
.modal-footer {
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  display: flex;
  text-align: right;
} 

.modal-footer-submit-btn {
  border-radius: 5px !important;
  background: #1890ff !important;
  box-shadow: 0 2px 8px rgba(9, 94, 180, 0.3);
  width: 125px !important;
  text-align: center;
}

/* 响应式设计 - 移动端适配 */
@media (max-width: 768px) {
  .protocol-modal-content {
    width: 95vw; /* 小屏幕上更宽 */
    max-height: 90vh; /* 高度增加 */
  }
  
  .modal-header {
    padding: 16px 20px;
  }
  
  .modal-header h2 {
    font-size: 0.5rem;
  }
  
  .protocol-text {
    padding: 20px;
    font-size: 13px; /* 移动端稍小字号 */
  }
  
  .modal-footer {
    padding: 14px 20px;
    flex-direction: column; /* 移动端按钮垂直排列 */
  }
}

.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}
</style>